import {Image, Space} from "antd";
import {useEffect} from "react";
import {Navbar} from "../../components/navbar";
import {
  StyledAuthFormWrapper,
  StyledChildrenAndImageWrapper,
  StyledChildrenWrapper,
  StyledImageWrapper,
  StyledLayout,
  StyledMainSection,
} from "./auth-form-wrapper.style";

import ReactGA from "react-ga";

interface IAuthFormWrapper {
  children: React.ReactNode;
}

const AuthFormWrapper: React.FC<IAuthFormWrapper> = ({children}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <StyledLayout>
      <Navbar />
      <StyledMainSection>
        <StyledChildrenAndImageWrapper>
          <StyledImageWrapper>
            <Image
              preview={false}
              width={"100%"}
              src="/images/auth-form-image.png"
              alt="Woman"
            />
          </StyledImageWrapper>
          <StyledChildrenWrapper>
            <StyledAuthFormWrapper>
              <Space direction="vertical" size={29} style={{display: "flex"}}>
                {children}
              </Space>
            </StyledAuthFormWrapper>
          </StyledChildrenWrapper>
        </StyledChildrenAndImageWrapper>
      </StyledMainSection>
    </StyledLayout>
  );
};

export {AuthFormWrapper};
